import { ViewResolver } from '@Components/index';

import useDictionaryLoader from './hooks/useDictionaryLoader';

import DesktopLayout from './desktop/DesktopLayout';
import MobileLayout from './mobile/MobileLayout';

interface EmployeeSelfServiceLayoutProps {
  children: JSX.Element | JSX.Element[];
}

const EmployeeSelfServiceLayout: React.FC<EmployeeSelfServiceLayoutProps> = ({
  children,
}) => {
  useDictionaryLoader();

  return (
    <ViewResolver
      desktop={<DesktopLayout>{children}</DesktopLayout>}
      mobile={<MobileLayout>{children}</MobileLayout>}
    />
  );
};

export default EmployeeSelfServiceLayout;
